/* stylelint-disable value-no-vendor-prefix, property-no-vendor-prefix */
import styled, { css } from 'styled-components';

import {
  BodySmall,
  H4,
  H6,
  Caption as StyledCaption,
} from '@/core/components/Typography';

import { breakpoint } from '@/themes/breakpoints';

export const Wrapper = styled.div<{ $withoutLastBorder?: boolean }>`
  display: flex;
  align-items: flex-start;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.neutral[300]}`};
  padding: 32px 0;
  gap: 16px;

  @media ${breakpoint.md} {
    align-items: center;
    padding: 40px 0;
  }
  ${({ $withoutLastBorder }) => ($withoutLastBorder ?
    css`
    &:last-of-type {
      border-bottom: none;
    }` :
    '')}
`;

export const ResourceImage = styled.img`
  width: 96px;
  height: 72px;
  transition: filter 0.5s ease;
  object-fit: cover;

  @media ${breakpoint.md} {
    width: 302px;
    height: 226px;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;

  @media ${breakpoint.md} {
    justify-content: center;
  }

  a {
    text-decoration: none;
  }
`;

export const Title = styled.h6`
  overflow: hidden;
  display: -webkit-box;
  max-width: calc(100vw - 144px);
  margin: 0;
  color: ${({ theme: { colors } }) => colors.black};
  font-weight: ${({ theme: { fontWeight } }) => fontWeight.regular};
  font-family: var(--executive-website-heading-font-family);
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  ${H6}

  @media ${breakpoint.sm} {
    max-width: calc(100vw - 176px);
  }

  @media ${breakpoint.md} {
    ${H4}
    max-width: calc(100vw - 550px);
  }

  @media ${breakpoint.lg} {
    max-width: calc(var(--max-margin-wrapper-width) - 390px);
  }
`;

export const Subtitle = styled.div`
  ${BodySmall}
  overflow: hidden;
  max-width: calc(100vw - 144px);
  margin: 0;
  color: ${({ theme }) => theme.colors.neutral[700]};
  text-overflow: ellipsis;
  white-space: nowrap;

  @media ${breakpoint.sm} {
    max-width: calc(100vw - 176px);
  }

  @media ${breakpoint.md} {
    max-width: calc(100vw - 550px);
    font-size: 16px;
    line-height: 200%;
  }

  @media ${breakpoint.lg} {
    max-width: calc(var(--max-margin-wrapper-width) - 390px);
  }
`;

export const Caption = styled.div`
  ${StyledCaption}
  margin: 0;
  margin-top: 16px;
  color: ${({ theme }) => theme.colors.neutral[700]};
`;

export const IconWrapper = styled.div`
  display: none;
  justify-content: flex-end;

  @media ${breakpoint.md} {
    display: flex;
  }
`;

export const ChipWrapper = styled.div`
  padding-top: 8px;
`;
